import { Image } from 'react-bootstrap';
import style from './Overlay.module.scss?module';
import { ProductSizeInterface } from '../../../../../../Interface/ProductSize';
import depositImage from '../../../../../../../public/images/pfand_img.webp';

const Overlay = ({ product_size }: { product_size: ProductSizeInterface }) => {
  return (
    <div>
      {product_size?.is_new ? <div className={style.new}>NEW!</div> : null}
      {product_size?.image_overlay_uri ? (
        <Image
          fluid
          className={style.overlayImage}
          src={product_size.image_overlay_uri}
          alt={product_size.name}
        />
      ) : null}
      {product_size?.single_deposit_price > 0 &&
      product_size?.deposit_units_count > 0 ? (
        <Image
          className={style.depositImage}
          src={depositImage}
          alt="deposit_image"
        />
      ) : null}
    </div>
  );
};

export default Overlay;
